import { render } from "./EditProjectTimeline.vue?vue&type=template&id=5963eb28"
import script from "./EditProjectTimeline.vue?vue&type=script&lang=js"
export * from "./EditProjectTimeline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__